<template>
  <el-dialog
    v-drag
    title="提示"
    :visible.sync="dialogVisible"
    width="440px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content" :loading="loading">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        label-width="80px"
      >
        <el-form-item label="是否推送ISF文件给客户" prop="isPush">
          <el-radio-group v-model="form.isPush">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.isPush" label="邮箱地址" prop="emails">
          <base-muti-input
            ref="baseMutiInput"
            v-model="form.emails"
            style="width: 320px"
          ></base-muti-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
import axios from 'axios'
const BaseMutiInput = () => import('@/components/base/BaseMutiInput.vue')
import { isfMainifestSave } from '@/api/bill'
import config from '@/utils/config'
export default {
  components: { BaseMutiInput },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    isfData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
        config,
      form: {
        emails: [],
        isPush: false
      },
      loading: false,
      rules: {
        emails: [{ required: true, message: '请输入邮箱', trigger: 'blur' }]
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.form = {
          emails: [],
          isPush: false
        }
      }
    }
  },
  methods: {
    async cancel() {
      this.$emit('ok')
      // try {
      //   const res = await axios({
      //     url: `/backEnd/api/${this.config.supplyCode}/ISF/isfMainifest`,
      //     method: 'post',
      //     responseType: 'blob',
      //     withCredentials: true,
      //     headers: {
      //       'Content-Type': 'application/json'
      //     },
      //     data: JSON.stringify(this.isfData)
      //   })
      //   const blob = new Blob([res.data], {
      //     type: 'application/pdf;chartset=UTF-8'
      //   })
      //   const pdfUrl = URL.createObjectURL(blob)
      //   window.open(pdfUrl, '_blank')
      // } catch (error) {
      //   console.error(error)
      // }
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          try {
            const params = {
              ...this.isfData,
              emails: this.form.emails
            }
            const res = await axios({
              url: `/api/ISF/isfMainifest`,
              method: 'post',
              responseType: 'blob',
              withCredentials: true,
              headers: {
                'Content-Type': 'application/json'
              },
              data: JSON.stringify(params)
            })
            const blob = new Blob([res.data], {
              type: 'application/pdf;chartset=UTF-8'
            })
            const pdfUrl = URL.createObjectURL(blob)
            const res1 = await isfMainifestSave(params)
            if (res1.success) {
              this.$message.success(res1.errorMessage)
              this.$emit('ok')
              window.open(pdfUrl, '_blank')
            }
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 320px;
  margin: 0 auto;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
